import { useSetRecoilState } from 'recoil'
import { NotificationInfoResult } from '../../services/web/types/responseWebServiceTypes'

import { notificationStore } from './appNotificationStore'

// type AlertMessageParamType = {
//     title?: string
//     message: string
// }
const useNotificationAction = () => {
    const setNotificationStore = useSetRecoilState(notificationStore)

    const setNotificationInfo = (notificationInfo: NotificationInfoResult[]) => {
        setNotificationStore((prevState) => ({
            ...prevState,
            notificationInfo: notificationInfo,
        }))
    }

    // const closeAlertMessage = () => {
    //     setAppAlertMessageStore((prevState) => ({
    //         ...prevState,
    //         isOpen: false,
    //         title: '',
    //         message: '',
    //     }))
    // }

    return {
        setNotificationInfo,
    }
}

export default useNotificationAction
